// import { dictionaryResponse } from './dictionary/dictionaryResponse'
// import { initialScript } from './helpers/initialScript'

// let proEnvironmentExecuted = false;

// function PRO_ENVIROMENT() {
//   if (proEnvironmentExecuted) return;
//   proEnvironmentExecuted = true;
//   dictionaryResponse();
//   initialScript();
// }

// document.addEventListener('DOMContentLoaded', function() {
//   PRO_ENVIROMENT();
// });

// window.onload = function() {
//   PRO_ENVIROMENT();
// };

import { dictionaryResponse } from './dictionary/dictionaryResponse'
import { initialScript } from './helpers/initialScript'

let proEnvironmentExecuted = false;

function PRO_ENVIROMENT() {
  if (proEnvironmentExecuted) return;
  proEnvironmentExecuted = true;
  dictionaryResponse();
  initialScript();
}

function PRE_ENVIRONMENT() {
  const script = document.createElement('script');
  script.src = "https://t.womtp.com/slider/c/grupo-planeta/planeta-preproduccion/build/satellite.js";
  document.head.appendChild(script);
}

function onReady() {
  if(window.location.href.indexOf("walmericTest") > -1){
    document.addEventListener('DOMContentLoaded', PRE_ENVIRONMENT);
    window.addEventListener('load', PRE_ENVIRONMENT);
    return;
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    
    PRO_ENVIROMENT();
  } else {
   
    document.addEventListener('DOMContentLoaded', PRO_ENVIROMENT);
    window.addEventListener('load', PRO_ENVIROMENT);
  }
}

onReady();
